<script>
export default {
  name: 'BaseLoadingSkeleton',
  props: {
    width: { type: String, default: '100%' },
    height: { type: String, default: '200px' },
  },
  computed: {
    range() {
      const q = Math.max(0, Number(this.quantity) || 0)
      // [0, 1, ..., q-1]
      return Array.from({ length: q }, (_, i) => i)
    },
    componentStyle() {
      const baseStyle = { width: this.width, height: this.height }
      const styleChain = []
      const vnodeData = this.$vnode.data || {}

      if (vnodeData.staticStyle) {
        styleChain.push(vnodeData.staticStyle)
      }

      if (vnodeData.style) {
        styleChain.push(vnodeData.style)
      }

      if (this.$attrs.style) {
        styleChain.push(this.$attrs.style)
      }

      styleChain.push(baseStyle)

      return styleChain.length === 1 ? styleChain[0] : styleChain
    },
    componentClass() {
      const vnodeData = this.$vnode.data || {}
      const classChain = []

      if (vnodeData.staticClass) {
        classChain.push(vnodeData.staticClass)
      }

      if (vnodeData.class) {
        classChain.push(vnodeData.class)
      }

      if (this.$attrs.class) {
        classChain.push(this.$attrs.class)
      }

      return classChain
    },
    componentAttrs() {
      const { style, type, class: omitClass, ...attrs } = this.$attrs
      return {
        ...attrs,
        style: this.componentStyle,
        'data-type': type,
      }
    },
  },
}
</script>

<template>
  <div>
    <div
      class="base-loading-skeleton"
      :class="componentClass"
      v-bind="componentAttrs"
    />
  </div>
</template>

<style lang="sass" scoped>
.skeleton-list
  height: 100% !important
  width: 100% !important

.base-loading-skeleton
  height: 100%
  width: 100%
  position: relative
  overflow: hidden
  background-color: #eeeeee
  border-radius: 6px

  &::before
    content: ''
    display: block
    width: 100%
    height: 100%
    background: linear-gradient(90deg,#0001 33%,#0005 50%,#0001 66%) #F0F1F3
    background-size:300% 300%
    animation: effectLoading 1s infinite linear
    position: absolute
    border-radius: 6px

@keyframes effectLoading
  0%
    background-position: right
</style>
